import { InteractiveRoomItem } from "$/game/prefabs/InteractiveRoomItem.ts";
import { BasicScene } from "$/game/prefabs/scenes/BasicScene.ts";

export class GameboyInteractiveObject extends InteractiveRoomItem {
  constructor(private myScene: BasicScene, x: number, y: number) {
    super(
      myScene,
      x,
      y,
      myScene.atlas,
      myScene.keys.assets.sprites.items.gameboy,
    );

    this.setOnClickCallback(async () => {
      // await this.myScene.api.pet.get();
      const pet = this.myScene.registry.get("pet");
      if (pet && pet.energy < 10) {
        this.myScene.overlay.show("StatRestoreOverlay", true, {
          pet,
          stat: "energy",
        });
      } else {
        this.myScene.transition.toScene(
          this.myScene.keys.scenes.miniGames.miniGamesListScene,
          this.myScene.keys.strings.sceneTransitions.gamesList,
        );
      }
    });
  }

  override destroy(): void {
    // this.myScene.tweens.killTweensOf(this);
    super.destroy();
  }
}
